import axios from 'axios'
import { Decode } from '@/services'

const GetToken = () => {
  if (localStorage.getItem('oneData') !== null) {
    const oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    const auth = {
      headers: { Authorization: `Bearer ${oneData.user.access_token}` }
    }
    return auth
  } else {
    const auth = ''
    return auth
  }
}

export default {
  async getSummaryOrder (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_DASHBOARD_API}iship/dashboard/summary`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getSummarySuccess (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_DASHBOARD_API}iship/dashboard/summary_success_order`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getSummaryPending (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_DASHBOARD_API}iship/dashboard/summary_in_progress_order`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getOverViewOnProcess (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_DASHBOARD_API}iship/dashboard/overview_on_process`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getOverViewOnProcessTable (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_DASHBOARD_API}iship/dashboard/overview_on_process_table`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getIshiplistAllShop (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_DASHBOARD_API}iship/listAllShop`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getAllOutSourceCourier (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}iship/outsoruce_courier_list`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async SentPickupAddress (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/iship/${data.seller_shop_id}/pickup_address`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async getAllOutSourceCourierII (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}v2/iship/outsoruce_courier_list`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateOrderV2 (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}v1/couriers/updateOrder`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetWithoutImages (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.get(`${process.env.VUE_APP_BACK_END2}iship/shipment/proof-images/${data.seller_shop_id}?${data.count !== '' ? `count=${data.count}` : ''}&${data.courier_code !== '' ? `courier_code=${data.courier_code}&` : ''}${data.start_date !== '' ? `start_date=${data.start_date}&` : ''}${data.end_date !== '' ? `end_date=${data.end_date}&` : ''}${data.search_keyword !== '' ? `search_keyword=${data.search_keyword}&` : ''}${data.page !== '' ? `page=${data.page}&` : ''}${data.status !== '' ? `status=${data.status}` : ''}`, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UploadProofOfDelivery (data) {
    const auth = await GetToken(data)
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}v1/iship/shipments/images`, data, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
